import React, { useState } from 'react'

import Rating from 'src/components/shared/rating'
import { TASK_VIEW } from 'src/constants'

import { ViewType } from '..'

type Props = {
    setOpen: (isOpen: boolean) => void
    setView: (value: ViewType) => void
}
const RateTaskQuality: React.FC<Props> = ({ setOpen, setView }) => {

    const [rating, setRating] = useState(0)

    const handleRating = (rate: number) => {
        setRating(rate)
    }

    return (
        <div className='flex flex-col justify-between min-h-[100px]'>
            <div className='flex flex-col items-center'>
                <p className='font-semibold'>Rate Task Quality</p>
                <Rating rating={rating} onRatingChange={handleRating} />
            </div>
            <button
                type="button"
                className="mt-3 inline-flex w-full justify-center
                 rounded-md bg-green-700 px-3 py-2 text-sm font-semibold
                  text-white hover:bg-green-700 
                  sm:mt-0 sm:w-auto"
                onClick={() => { setOpen(false); setView(TASK_VIEW.info) }}>
                Submit
            </button>
        </div>
    )
}

export default RateTaskQuality
